import { Select } from "antd";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

export const BUFFER_TIME_MAX_MINUTES = 240;
export const BUFFER_TIME_OPTIONS = Array.from(
    { length: BUFFER_TIME_MAX_MINUTES / 30 },
    (_, index) => (index + 1) * 30,
);

export const formatBufferTimeLabel = (minutes, t) => {
    if (minutes < 60) {
        return t("preferences.bufferTimeOptionMinutes", { count: minutes });
    }

    const hours = Math.floor(minutes / 60);
    const remainder = minutes % 60;

    if (remainder === 0) {
        return hours === 1
            ? t("preferences.bufferTimeOptionOneHour")
            : t("preferences.bufferTimeOptionHours", { count: hours });
    }

    return hours === 1
        ? t("preferences.bufferTimeOptionOneHourHalf", { minutes: remainder })
        : t("preferences.bufferTimeOptionHoursHalf", { hours, minutes: remainder });
};

const BufferTimeSelector = ({ id, value, onChange, disabled = false }) => {
    const { t } = useTranslation("settings");

    return (
        <Select
            id={id}
            value={value}
            onChange={onChange}
            disabled={disabled}
            size="small"
            className="w-full min-w-0 sm:min-w-[11rem] sm:w-auto"
            getPopupContainer={() => document.body}
            options={BUFFER_TIME_OPTIONS.map((minutes) => ({
                value: minutes,
                label: formatBufferTimeLabel(minutes, t),
            }))}
        />
    );
};

BufferTimeSelector.propTypes = {
    id: PropTypes.string,
    value: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
};

export default BufferTimeSelector;
